import React, { useEffect, useState } from 'react';
import AxiosInstance from '../../server/AxioInstance';
import MenuButton from '../../components/common/menuButton/MenuButton';
import { Grid } from '@mui/material';
import { HowToRegIcon, PendingActionsIcon } from '../../shared/components/icon';
import { useSnackbar } from '../../shared/context';
import { useNavigate } from 'react-router-dom';

const Notice = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [pedindDocuments, setPedindDocuments] = useState(0);
  const [pedindPublish, setPedindPublish] = useState(0);
  const login = localStorage.getItem('@gedy:user');

  const handleChangeColorPeding = () => {
    return pedindDocuments > 5 ? 'error' : pedindDocuments > 0 ? 'warning' : 'success';
  };

  const handleChangeColorPublish = () => {
    return pedindPublish > 5 ? 'error' : pedindPublish > 0 ? 'warning' : 'success';
  }

  const handleRedirect = (link) => {
    navigate(link);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const document_peding_approval = await AxiosInstance.post('/notice/pending-approval', {
          login: login,
        });
        setPedindDocuments(document_peding_approval.data.quantidadeDocumentosPendentes);

        const document_peding_publish = await AxiosInstance.post('/notice/pending-publish', {
          login: login,
        });
        setPedindPublish(document_peding_publish.data.amountPendingPublish);

      } catch (error) {
        showSnackbar({
          vertical: 'top',
          horizontal: 'right',
          message: error.message,
          variant: 'error',
        });
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const color = handleChangeColorPeding();
  const colorPublish = handleChangeColorPublish();

  return (
    <Grid container spacing={1}>
      <Grid item key='Documentos Pendentes' xs={12} sm={6} md={4}>
        <MenuButton
          title={'Docs pendentes de aprovação : ' + pedindDocuments}
          icon={<PendingActionsIcon color={color} sx={{ fontSize: '10em' }} />}
          onClick={() => handleRedirect(`/CreateDocument/validation`)}
        />
      </Grid>
      <Grid item key='Documentos Pendentes' xs={12} sm={6} md={4}>
        <MenuButton
          title={'Docs pendentes de publicação : ' + pedindPublish}
          icon={<HowToRegIcon color={colorPublish} sx={{ fontSize: '10em' }} />}
          onClick={() => handleRedirect(`/CreateDocument/publish`)}
        />
      </Grid>
    </Grid>
  );
};

export default Notice;
